<mat-dialog-content class="mat-dialog-content">
  <div fxLayout="row" fxLayoutAlign="end">
    <div>
      <button mat-icon-button class="close" (click)="close()">
        <span class="close">
          <mat-icon>
            close
          </mat-icon>
        </span>
      </button>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center stretch" class="body">
    <p>
      <span i18n>
        You have been selected for a survey.<br /><br />
        We appreciate your feedback! <br />
        Please
      </span>
      <a target="popup" (click)="openSurvey()" i18n>
        click here
      </a>
      <span i18n>start it now. <br /><br /></span>
      <mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
        <button class="nav-button" mat-button (click)="close()" fxFlex>
          <span i18n>Maybe later</span>
        </button>
      </mat-dialog-actions>
    </p>
  </div>
  <div fxLayout="row" fxLayoutAlign="center stretch" class="body">
    <div class="msg-bubble" *ngIf="showMessage">
      <mat-icon>announcement</mat-icon>
      <span i18n>system error: please contact Finishline Service Desk</span>
    </div>
  </div>
</mat-dialog-content>


